/**
 * Converts technical field names from camelCase or PascalCase to user-friendly display labels
 * by adding spaces between words.
 * 
 * @param text - The technical field name (e.g., 'SupplierName', 'DocumentUpload')
 * @returns The formatted display label (e.g., 'Supplier Name', 'Document Upload')
 * 
 * @example
 * formatFieldName('SupplierName') // returns 'Supplier Name'
 * formatFieldName('CustomerEmailAddress') // returns 'Customer Email Address'
 * formatFieldName('OrderStatusUpdate') // returns 'Order Status Update'
 */
export function formatFieldName(text: string | null | undefined): string {
  if (!text) return '-';
  
  // Insert space before capital letters that follow lowercase letters or numbers
  // This handles camelCase and PascalCase
  const formatted = text
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2');
  
  // Capitalize first letter if not already
  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
}

/**
 * Converts technical action type names to user-friendly display labels
 * 
 * @param actionType - The technical action type (e.g., 'StatusChange', 'ValueChange')
 * @returns The formatted display label (e.g., 'Status Change', 'Value Change')
 */
export function formatActionType(actionType: string | null | undefined): string {
  if (!actionType) return '-';
  return formatFieldName(actionType);
}
